import { useDialog } from './use-dialog';
export const usePromiseDialog = (props) => {
    const { lazyChildren } = props;
    const { showDialog, hideDialog } = useDialog({ lazyChildren });
    return {
        show: (dialogProps) => new Promise(resolve => {
            showDialog({
                ...dialogProps, // Cast needed due to TypeScript limitations with generics
                onConfirm: () => {
                    resolve(true);
                    hideDialog();
                },
                onCancel: () => {
                    resolve(false);
                    hideDialog();
                },
            });
        }),
    };
};
